function updateAbout(state, {data, glb}) {
    state.geo = data.geo;
    state.brokerageInfo = data.brokerageInfo;
    state.managementMembers = data.managementMembers;
}
export default {
    updateAbout
};
